<section class="section-wrapper">
  <ng-container *ngIf="payload.patientWarningList.length > 0">
  <ul class="table-wrapper">
      <li class="table-row">
        <span class="table-column name">
          Patient Name
        </span>      
        <span class="table-column mrn">
          MRN
        </span>
        <span class="table-column birth-date">
          Date of Birth
        </span>
        <span class="header work-flow-count">
          Associated active worklist items
        </span>
      </li>
      <li class="table-row" *ngFor="let user of payload.patientWarningList;trackBy:trackByFn"
        [ngClass]="{'selected':user.id === selectedUser}">
        <span class="table-column name">
          {{user.name}}
      </span>
        <div class="table-column-mrn">
          <span *ngIf="user.showToolTip" genTooltip [tooltipHtml]="user.toolTip" [tooltipPosition]="'TOP'"
          [appendToBody]="'true'" [tooltipShow]="true"><img style="height: 1.3rem;" src="assets/ispm/icons/Info_Icon.png" >
      </span>
      <span class="table-column mrn">
            {{user.mrn}}
      </span>
        </div>
      <span class="table-column birth-date">
          {{user.dob}}
      </span>
        <span class="table-column work-flow-count">
          {{user.workFlowCount}}
        </span>          
    </li>
  </ul>
  </ng-container>
  <br>
</section>
